<!--page starts-->
<section class="page-wrapper">
    <div class="event-hero-section margin-top-152 cf" [ngStyle]="{'background-image':'url(' + bannerList?.file + ')'}">
        <div class="container">
            <div class="event-hero-detail">
                <div class="event-hero-titel">
                    
                </div>
            </div>
        </div>
    </div>
    <div class="ticket-bottom-section" style="background-image: url(assets/images/tickets-bg-banner.jpg);">
        <div class="container">
            <div class="ticket-bottom-detail">
                <div class="ticket-bottom-box">
                    <a routerLink="/buytickets">
                        <h2>Buy Tickets</h2>
                        <p>The early years of the 18th century show that cricket arrived in Leicestershire from its birthplace in Kent, </p>
                        <div class="ticket-fox-box">
                            <img src="assets/images/ic-logo-new.png">
                        </div>
                    </a>
                </div>
                <div class="ticket-bottom-box">
                    <a routerLink="/matchtickets">
                        <h2>2021 Blast Pass -<br> On Sale Now!</h2>
                        <p>The early years of the 18th century show that cricket arrived in Leicestershire from its birthplace in Kent,  </p>
                        <div class="ticket-fox-box">
                            <img src="assets/images/ic-logo-new.png">
                        </div>
                    </a>
                </div>
                <div class="ticket-bottom-box">
                    <a routerLink="/outdoor-tickets">
                        <h2>2021 T20 Priority<br> Ticket Window</h2>
                        <p>The early years of the 18th century show that cricket arrived in Leicestershire from its birthplace in Kent, </p>
                        <div class="ticket-fox-box">
                            <img src="assets/images/ic-logo-new.png">
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>
</section><!-- page ends-->
